import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import AccessDenied from "./AccessDenied";

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  fallbackPath?: string;
  showAccessDenied?: boolean;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  allowedRoles,
  fallbackPath = "/dashboard",
  showAccessDenied = true,
}) => {
  const { user, isAuthenticated } = useAuth();

  // Если пользователь не авторизован, перенаправляем на страницу входа
  if (!isAuthenticated || !user) {
    return <Navigate to="/signin" replace />;
  }

  // Проверяем, есть ли у пользователя хотя бы одна из разрешенных ролей
  const hasRequiredRole = user.roles.some((role) => allowedRoles.includes(role));

  if (!hasRequiredRole) {
    // Если у пользователя нет нужных ролей, показываем страницу доступа запрещен или перенаправляем
    if (showAccessDenied) {
      return <AccessDenied />;
    } else {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
